module.exports = __webpack_public_path__ + "static/media/AppMarket_001.fb7a0db9.png";